module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[22]21.c8ef06d.woff2";